<template>
  <div id="printable" class="register-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">MOH 406 - POSTNATAL REGISTER</div>
    </div>

    <!-- Date Range and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="date-range">
          <div class="info-item">
            <span class="info-label">From:</span>
            <input
              type="date"
              v-model="dateFrom"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <div class="info-item">
            <span class="info-label">To:</span>
            <input
              type="date"
              v-model="dateTo"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <button @click="clearDates" class="btn-clear">Clear</button>
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">Print Register</button>
    </div>

    <!-- Date Range Display for Print -->
    <div class="print-date-range">
      <strong>Report Period:</strong> {{ formattedDateFrom }} to
      {{ formattedDateTo }}
    </div>

    <!-- Summary Statistics -->
    <div class="summary-stats">
      <div class="stat-box">
        <span class="stat-label">Total Postnatal Visits</span>
        <span class="stat-number">{{ totalVisits }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Day 7 Visits</span>
        <span class="stat-number">{{ day7Visits }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Day 42 Visits</span>
        <span class="stat-number">{{ day42Visits }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Exclusive BF</span>
        <span class="stat-number">{{ exclusiveBreastfeeding }}</span>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="postnatal-table">
        <thead>
          <tr>
            <th rowspan="2">#</th>
            <th rowspan="2">Date of Visit</th>
            <th rowspan="2">PNC No</th>
            <th rowspan="2">Full Names</th>
            <th rowspan="2">Age</th>
            <th rowspan="2">Delivery Date</th>
            <th rowspan="2">Days Postpartum</th>
            <th rowspan="2">Contact</th>
            <th rowspan="2">SubLocation</th>
            <th colspan="2">Maternal Assessment</th>
            <th colspan="3">Baby Assessment</th>
            <th rowspan="2">Family Planning</th>
            <th rowspan="2">HIV Status</th>
            <th rowspan="2">Nutrition</th>
            <th rowspan="2">Next Visit</th>
            <th rowspan="2">Remarks</th>
          </tr>
          <tr class="sub-header">
            <th>BP</th>
            <th>Lochia</th>
            <th>Baby Weight</th>
            <th>Feeding</th>
            <th>Immunizations</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in filteredRecords" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ record.visitDate }}</td>
            <td>{{ record.pncNo }}</td>
            <td>{{ record.fullNames }}</td>
            <td>{{ record.age }}</td>
            <td>{{ record.deliveryDate }}</td>
            <td>{{ record.daysPostpartum }}</td>
            <td>{{ record.contact }}</td>
            <td>{{ record.subLocation }}</td>
            <td class="text-center">{{ record.bp }}</td>
            <td class="text-center">
              <span
                :class="{
                  'normal-badge': record.lochia === 'Normal',
                  'warning-badge': record.lochia === 'Abnormal',
                }"
              >
                {{ record.lochia }}
              </span>
            </td>
            <td class="text-center">{{ record.babyWeight }}</td>
            <td class="text-center">
              <span v-if="record.feeding === 'Exclusive BF'" class="yes-badge"
                >Exclusive BF</span
              >
              <span
                v-else-if="record.feeding === 'Mixed Feeding'"
                class="warning-badge"
                >Mixed</span
              >
              <span v-else class="na-badge">--</span>
            </td>
            <td class="text-center">
              <span v-if="record.immunizations" class="yes-badge">Given</span>
              <span v-else class="no-badge">Pending</span>
            </td>
            <td class="text-center">
              <span v-if="record.familyPlanning" class="yes-badge">{{
                record.familyPlanning
              }}</span>
              <span v-else class="no-badge">None</span>
            </td>
            <td class="text-center">
              <span v-if="record.hivStatus === 'Positive'" class="positive"
                >Positive</span
              >
              <span v-else-if="record.hivStatus === 'Negative'" class="negative"
                >Negative</span
              >
              <span v-else class="na-badge">--</span>
            </td>
            <td class="text-center">
              <span v-if="record.nutrition" class="yes-badge">{{
                record.nutrition
              }}</span>
              <span v-else class="na-badge">--</span>
            </td>
            <td>{{ record.nextVisit }}</td>
            <td>{{ record.remarks }}</td>
          </tr>
          <tr v-if="filteredRecords.length === 0">
            <td colspan="18" class="empty-row">
              No postnatal records found for the selected date range
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH406Postnatal",
  data() {
    return {
      dateFrom: "2026-04-01",
      dateTo: "2026-04-30",
      generatedBy: "SR. JANE KAREGI MUNYUGI",
      postnatalRecords: [
        {
          visitDate: "2026-04-22",
          pncNo: "PNC001",
          fullNames: "Mary Wanjiku",
          age: 28,
          deliveryDate: "2026-04-22",
          daysPostpartum: 0,
          contact: "0712345678",
          subLocation: "Kianjai",
          bp: "110/70",
          lochia: "Normal",
          babyWeight: "3.2",
          feeding: "Exclusive BF",
          immunizations: true,
          familyPlanning: "None",
          hivStatus: "Negative",
          nutrition: "Vit A",
          nextVisit: "2026-04-29",
          remarks: "Mother and baby well",
        },
        {
          visitDate: "2026-04-22",
          pncNo: "PNC002",
          fullNames: "Grace Muthoni",
          age: 32,
          deliveryDate: "2026-04-15",
          daysPostpartum: 7,
          contact: "0723456789",
          subLocation: "Mutuati",
          bp: "118/75",
          lochia: "Normal",
          babyWeight: "3.0",
          feeding: "Exclusive BF",
          immunizations: true,
          familyPlanning: "Condoms",
          hivStatus: "Negative",
          nutrition: "Vit A",
          nextVisit: "2026-05-06",
          remarks: "Day 7 visit completed",
        },
        {
          visitDate: "2026-04-21",
          pncNo: "PNC003",
          fullNames: "Jane Karimi",
          age: 35,
          deliveryDate: "2026-04-10",
          daysPostpartum: 11,
          contact: "0734567890",
          subLocation: "Kangeta",
          bp: "125/85",
          lochia: "Normal",
          babyWeight: "2.9",
          feeding: "Mixed Feeding",
          immunizations: true,
          familyPlanning: "Implant",
          hivStatus: "Negative",
          nutrition: "Vit A",
          nextVisit: "2026-05-21",
          remarks: "Baby gaining weight well",
        },
        {
          visitDate: "2026-04-20",
          pncNo: "PNC004",
          fullNames: "Sarah Mwikali",
          age: 24,
          deliveryDate: "2026-03-10",
          daysPostpartum: 41,
          contact: "0745678901",
          subLocation: "Laare",
          bp: "115/70",
          lochia: "Normal",
          babyWeight: "4.5",
          feeding: "Exclusive BF",
          immunizations: true,
          familyPlanning: "Pills",
          hivStatus: "Negative",
          nutrition: "Vit A",
          nextVisit: "2026-05-20",
          remarks: "Day 42 visit, both healthy",
        },
        {
          visitDate: "2026-04-19",
          pncNo: "PNC005",
          fullNames: "Lucy Mwende",
          age: 29,
          deliveryDate: "2026-04-19",
          daysPostpartum: 0,
          contact: "0756789012",
          subLocation: "Kianjai",
          bp: "108/68",
          lochia: "Normal",
          babyWeight: "2.5",
          feeding: "Exclusive BF",
          immunizations: true,
          familyPlanning: "None",
          hivStatus: "Negative",
          nutrition: "Vit A",
          nextVisit: "2026-04-26",
          remarks: "Preterm baby, NBU review",
        },
        {
          visitDate: "2026-04-18",
          pncNo: "PNC006",
          fullNames: "Esther Kendi",
          age: 41,
          deliveryDate: "2026-04-18",
          daysPostpartum: 0,
          contact: "0767890123",
          subLocation: "Mutuati",
          bp: "130/90",
          lochia: "Normal",
          babyWeight: "3.1",
          feeding: "Exclusive BF",
          immunizations: true,
          familyPlanning: "None",
          hivStatus: "Negative",
          nutrition: "Vit A",
          nextVisit: "2026-04-25",
          remarks: "Monitor BP",
        },
        {
          visitDate: "2026-04-17",
          pncNo: "PNC007",
          fullNames: "Ruth Nkirote",
          age: 26,
          deliveryDate: "2026-04-10",
          daysPostpartum: 7,
          contact: "0778901234",
          subLocation: "Kangeta",
          bp: "120/78",
          lochia: "Abnormal",
          babyWeight: "3.0",
          feeding: "Exclusive BF",
          immunizations: true,
          familyPlanning: "Condoms",
          hivStatus: "Positive",
          nutrition: "Vit A",
          nextVisit: "2026-04-24",
          remarks: "Lochia abnormal, on ARVs",
        },
        {
          visitDate: "2026-04-16",
          pncNo: "PNC008",
          fullNames: "Naomi Gacheri",
          age: 33,
          deliveryDate: "2026-03-06",
          daysPostpartum: 41,
          contact: "0789012345",
          subLocation: "Laare",
          bp: "115/72",
          lochia: "Normal",
          babyWeight: "4.8",
          feeding: "Exclusive BF",
          immunizations: true,
          familyPlanning: "Implant",
          hivStatus: "Negative",
          nutrition: "Vit A",
          nextVisit: "2026-05-16",
          remarks: "Day 42 visit, healthy",
        },
        {
          visitDate: "2026-04-15",
          pncNo: "PNC009",
          fullNames: "Mercy Kajuju",
          age: 22,
          deliveryDate: "2026-04-08",
          daysPostpartum: 7,
          contact: "0790123456",
          subLocation: "Kianjai",
          bp: "110/65",
          lochia: "Normal",
          babyWeight: "3.3",
          feeding: "Exclusive BF",
          immunizations: true,
          familyPlanning: "Pills",
          hivStatus: "Negative",
          nutrition: "Vit A",
          nextVisit: "2026-05-15",
          remarks: "First time mother",
        },
      ],
    };
  },
  computed: {
    formattedDateFrom() {
      return this.dateFrom
        ? new Date(this.dateFrom).toLocaleDateString("en-GB")
        : "Start";
    },
    formattedDateTo() {
      return this.dateTo
        ? new Date(this.dateTo).toLocaleDateString("en-GB")
        : "End";
    },
    filteredRecords() {
      let filtered = this.postnatalRecords;
      if (this.dateFrom) {
        filtered = filtered.filter((r) => r.visitDate >= this.dateFrom);
      }
      if (this.dateTo) {
        filtered = filtered.filter((r) => r.visitDate <= this.dateTo);
      }
      return filtered;
    },
    totalVisits() {
      return this.filteredRecords.length;
    },
    day7Visits() {
      return this.filteredRecords.filter((r) => r.daysPostpartum === 7).length;
    },
    day42Visits() {
      return this.filteredRecords.filter(
        (r) => r.daysPostpartum === 41 || r.daysPostpartum === 42,
      ).length;
    },
    exclusiveBreastfeeding() {
      return this.filteredRecords.filter((r) => r.feeding === "Exclusive BF")
        .length;
    },
  },
  methods: {
    clearDates() {
      this.dateFrom = "";
      this.dateTo = "";
    },
    filterRecords() {
      // Computed property handles filtering
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.date-range {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.date-input {
  padding: 5px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
}

.btn-clear {
  padding: 5px 12px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
}

.btn-clear:hover {
  background: #4b5563;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}

.btn-print:hover {
  background: #2563eb;
}

.print-date-range {
  text-align: center;
  padding: 8px;
  margin-bottom: 16px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

.summary-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.stat-box {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-radius: 12px;
  padding: 12px 20px;
  text-align: center;
  min-width: 150px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #bfdbfe;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.stat-number {
  display: block;
  font-size: 26px;
  font-weight: bold;
  color: white;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-height: 65vh;
  overflow-y: auto;
}

.postnatal-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 1500px;
}

.postnatal-table th {
  background: #1f2937;
  color: white;
  padding: 8px 4px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
  z-index: 10;
}

.postnatal-table th.sub-header {
  background: #374151;
  font-size: 10px;
}

.postnatal-table td {
  border: 1px solid #d1d5db;
  padding: 6px 4px;
  text-align: left;
}

.postnatal-table td.text-center {
  text-align: center;
}

.yes-badge {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.no-badge {
  background: #fee2e2;
  color: #991b1b;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.normal-badge {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.warning-badge {
  background: #fef3c7;
  color: #92400e;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.positive {
  background: #fee2e2;
  color: #dc2626;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.negative {
  background: #d1fae5;
  color: #059669;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.na-badge {
  color: #9ca3af;
  font-weight: 500;
}

.empty-row {
  text-align: center;
  padding: 30px;
  color: #6b7280;
}

@media print {
  @page {
    size: landscape;
    margin: 0.3cm;
  }

  .btn-print,
  .btn-clear,
  .date-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-date-range {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-stats {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .table-wrapper {
    overflow: visible !important;
    max-height: none;
  }

  .postnatal-table {
    font-size: 8px;
    min-width: 0 !important;
  }

  .postnatal-table th {
    padding: 3px 2px;
    font-size: 8px;
    background: #e5e7eb !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .postnatal-table td {
    padding: 3px 2px;
    font-size: 7.5px;
  }
}
</style>
